import { c as _c } from "react/compiler-runtime";
import { requestIdleCallback } from '@cc-shopping/utils/requestIdleCallback';
import { useShallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../../store/Context';
import { useFiltersAnalytics } from '../../store/hooks/useFiltersAnalytics';
import type { OffersFilterStoreState } from '../../store/types';
import { Pill } from './Pill';
export function ClearAllButton() {
  const $ = _c(7);
  const {
    handleApplyFilters,
    handleClearFilters,
    selectedNonDefaultFilters
  } = useOffersFilterStore(useShallow(_temp));
  const {
    fireClearAllEvents
  } = useFiltersAnalytics();
  let t0;
  if ($[0] !== fireClearAllEvents || $[1] !== handleApplyFilters || $[2] !== handleClearFilters) {
    t0 = () => {
      handleClearFilters();
      requestIdleCallback(() => {
        handleApplyFilters();
        fireClearAllEvents();
      });
    };
    $[0] = fireClearAllEvents;
    $[1] = handleApplyFilters;
    $[2] = handleClearFilters;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleClearAll = t0;
  const t1 = selectedNonDefaultFilters.length === 0;
  let t2;
  if ($[4] !== handleClearAll || $[5] !== t1) {
    t2 = <Pill disabled={t1} onClick={handleClearAll} fontSize="14px" shouldHideCloseIcon={true}>Clear All</Pill>;
    $[4] = handleClearAll;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(state) {
  return {
    handleApplyFilters: state.handleApplyFilters,
    handleClearFilters: state.handleClearFilters,
    selectedNonDefaultFilters: state.selectedNonDefaultFilters
  };
}